import styled from "styled-components";
import {
  ButtonCreate,
  ButtonAlternative,
  ButtonAlter,
} from "../../styles-components/Buttons";

export const ListHeader = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 10px;


  span {
    font-size: 2rem;
    color: var(--orange);
  }

  div + span {
    color: var(--dark-gray);
    margin: 0 15px;
  }

  div ${ButtonAlternative}, ${ButtonAlter} {
    margin-top: auto;
  }

  ${ButtonCreate} {
    text-align: right;
    margin-top: 10px;
    margin-left: auto;
  }

  @media (max-width: 760px) {
    flex-direction: column-reverse;

    div + span {
      display: none;
    }

    ${ButtonCreate} {
      text-align: center;
    }

    div {
      align-self: center;
    }

    div span {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 570px) {
    div ${ButtonAlternative}, ${ButtonAlter} {
      padding: 10px;
    }
  }
`;
